const typeOfPays = [
  { code: 'ND', name: 'Non-disability' },
  { code: 'D', name: 'Disability' },
  { code: 'N', name: 'None' }
];

export default typeOfPays;
